const translationsByLocale = {
    'en-gb': {
        carouselAriaLabel: 'Carousel',
        tabsAriaLabel: 'Tabs',
        dropdownInputPlaceholder: 'Select option ...',
        selectInputPlaceholder: 'Select option ...',
        Open: 'Open',
        Close: 'Close',
    },
    'de-de': {
        Open: 'Öffnen',
        Close: 'Schließen',
    },
    'es-es': {
        Open: 'Abrir',
        Close: 'Cerrar',
    },
    'it-it': {
        Open: 'Apri',
        Close: 'Chiudi',
    },
    'ru-ru': {
        Open: 'Открыть',
        Close: 'Закрыть',
    },
    'el-gr': {
        Open: 'Ανοιξε',
        Close: 'Κλείσε',
    },
    'ja-jp': {
        Open: '開く',
        Close: '閉じる',
    },
};
export default translationsByLocale;
